import { Input, Component } from '@angular/core';

import { Location } from '@shared/location/models';
import { LocationSwitcherService } from '../../../../../../libs/frontend-location-switcher/src/lib/location-switcher';
import { Address } from '@shared/restaurant/models';

@Component({
  selector: 'tablesready-location-name-column',
  templateUrl: './location-name-column.component.html',
})
export class LocationNameColumnComponent {
  @Input() location: Location;
  @Input() currentLocationId: string;
  @Input() email: string;

  constructor(private readonly locationSwitcherService: LocationSwitcherService) {}

  navigateToLocationPage(locationId: string, url: string): void {
    this.locationSwitcherService.navigateToLocationPage(locationId, url);
  }

  getAddressString(address: Address | null): string {
    return address
      ? [address.primaryAddress, address.postalCode, address.city].filter(item => !!item).join(', ')
      : '';
  }
}
